import { Button, useModal } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { ModalId } from '../../../../../../enums/modalId'
import { Scope } from '../../../../../../enums/scope'
import { useSegment } from '../../../../../../hooks'
import { isAuthorized } from '../../../../../../utils/isAuthorized'

export const CreateDepositInvoiceButton = (): ReactElement => {
  const { t } = useTranslation()
  const { track } = useSegment()
  const { open: openDepositInvoiceEntryPointModal } = useModal(ModalId.CreateDepositInvoiceEntryPointModal)
  const { open: openUpgradeSubscriptionModal } = useModal(ModalId.UpgradeSubscriptionModal)

  const shouldOfferUpgrade = isAuthorized(Scope.OfferConvertToInvoiceUpsell)

  const handleCreateDepositInvoiceClick = useCallback(() => {
    track('XXX - Invoicing Core - Invoices List - Create deposit invoice button clicked')

    if (shouldOfferUpgrade) {
      openUpgradeSubscriptionModal()
      return
    }
    openDepositInvoiceEntryPointModal()
  }, [openDepositInvoiceEntryPointModal, openUpgradeSubscriptionModal, shouldOfferUpgrade, track])

  return (
    <Button icon="circlePlus" onClick={handleCreateDepositInvoiceClick} variant="outlined">
      {t('external_invoices.deposit_invoice.create_deposit_invoice')}
    </Button>
  )
}
